import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import MainNavigation from 'src/components/Layout/MainNavigation/MainNavigation';
import UpgradeButton from 'src/components/ui/GlobalComponents/UpgradeButton/UpgradeButton';
import { IconLocation } from 'src/utils/URLUtils';
import styles from './Header.module.scss';
import { LearnProgressChart } from './LearnProgressChart/LearnProgressChart';

const Header = () => {
    const { t } = useTranslation();
    const [showNavigation, setShowNavigation] = useState(false);
    const navigate = useNavigate();

    const toggleNavigation = () => {
        setShowNavigation(prevState => !prevState);
    };

    return (
        <section className={styles.header} >
            <MainNavigation toggleNavigation={toggleNavigation} show={showNavigation} />
            <img
                className={styles.menu}
                src={IconLocation('menu', true)}
                alt={t('menu')}
                onClick={toggleNavigation}
            />
            <div className={styles.searchContainer}>
                <img
                    className={styles.searchImage}
                    onClick={() => navigate('/search')}
                    src={'https://s3.eu-west-1.amazonaws.com/cdn-wordup.com/AppImages/Icons/black/home-search.png'}
                    alt={t('search')}
                />
                <LearnProgressChart />
                <UpgradeButton />
            </div>
        </section>
    );
};

export default Header;